// removed by extract-text-webpack-plugin
module.exports = {"page":"_17ys2O_Y","content":"_17TS95fR"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/pages/LegalPage/LegalPage.styl
// module id = 354
// module chunks = 0